<script setup>
import { ref } from "vue"
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	user: {
		type: Object,
		required: true
	},
})

const button = ref(null) // template ref

function resetPassword() {
	errors.confirm({
		title: "Reset Password",
		message: "Are you sure you want to reset this user's password?",
		type: "danger",
		btnText: "Reset Password",
		onConfirm: () => {
			button.value.waitFor(
				axios.post('/users/' + props.user.id + '/reset-password')
				.then((response) => {
					if( response.data.status == 'success' ) {
						errors.push({
							title: 'Success',
							message: 'Password reset email sent to ' + props.user.email,
							type: 'success'
						})
					}
				})
			)
		}
	})
}
</script>

<template>
	<PromiseButton
		ref="button"
		color="blue"
		type="button"
		@click="resetPassword"
	>
		Reset Password
	</PromiseButton>
</template>